import { z } from 'zod';

/**
 * Shape of a single terminus indicator entry inside the
 * `info` / `error` / `details` maps of a health check result.
 * `status` is `'up'` or `'down'`; extra fields (message, latency, etc.)
 * are indicator-specific and left as a passthrough record.
 */
export const HealthIndicatorEntrySchema = z.object({
  status: z.enum(['up', 'down']),
});

/**
 * Response shape for `/health`, `/health/liveness`, `/health/readiness`.
 * Mirrors `@nestjs/terminus`'s `HealthCheckResult`.
 */
export const HealthCheckResultSchema = z.object({
  status: z.enum(['ok', 'error', 'shutting_down']),
  info: z.record(z.string(), HealthIndicatorEntrySchema).optional(),
  error: z.record(z.string(), HealthIndicatorEntrySchema).optional(),
  details: z.record(z.string(), HealthIndicatorEntrySchema),
});
